<template>
    <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{testResult.TargetSystem.Name}} - {{translate('targetSystemTest.connectionTest')}}</h5>
                <button type="button" class="close" data-dismiss="modal"  :aria-label="translate('close')" @click="$emit('onclose')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row" v-show="testResult">
                    <div class="col">
                        <div v-bind:class="[ testResult.Success ? 'alert-success' : 'alert-danger', 'alert' ]" role="alert">
                            {{testResult.Result}}
                        </div>
                    </div>
                </div>
                <div class="row" v-show="testResult.Logs">
                    <div class="col">
                        <h5>{{translate('targetSystemTest.testSteps')}}
                            <small class="text-right text-muted float-right" v-if="testResult.Date">{{translate('targetSystemTest.testDate')}}: {{testResult.Date | datetime}}</small>
                        </h5>
                        <div class="form-control" style="height:400px; overflow-y:scroll; padding:0">
                            <table class="table table-striped table-condensed" style="margin-top:-1px">
                                <tbody v-for="e in testResult.Logs" :key="e.Date">
                                    <tr @click="showDetails(e)" style="cursor:pointer">
                                        <td>
                                            <b v-bind:class="textClass(e)" >{{e.Subject}}</b>
                                        </td>
                                        <td class="text-right">{{e.Date | datetime}}</td>
                                    </tr>
                                    <tr v-show="e.showDetails || e.State == 'Error' ">
                                        <td colspan="2">
                                            <pre style="white-space:pre-line;">{{e.Body}}</pre>
                                            <div v-show="e.Suggestion" class="alert alert-primary" role="alert">
                                                <h4 class="alert-heading">{{translate('targetSystemTest.suggestion')}}</h4>
                                                <p>{{e.Suggestion}}</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer footer-button-container">
                <button type="button" class="btn btn-outline-secondary" @click="$emit('onclose')">{{translate('close')}}</button>
            </div>
        </div>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        testResult: Object
    },
    components: {

    },
    computed:{
    },
    methods: {
        textClass(e) {
            return {            
            'text-info': e.State == 'Information' ,
            'text-success': e.State == 'Success',
            'text-warning': e.State == 'Warning',
            'text-danger': e.State == 'Error'
            }
        },        
        showDetails(e) {
            e.showDetails = !(e.showDetails || false);
            console.log('showDetails:', e.showDetails);
            this.$forceUpdate();            
        }
    }
}
</script>